import {
  RoutineDayEntry,
  RoutineDefinition,
  RoutineHistoryRecord,
  RoutineInput,
  RoutineStatus
} from '../models/routine.model';

export abstract class RoutinesRepository {
  abstract materializeDate(date: string): Promise<void>;
  abstract materializeDates(dates: string[]): Promise<void>;
  abstract getRoutinesForDate(date: string): Promise<RoutineDayEntry[]>;
  abstract getRoutineHistory(
    definitionIds: number[],
    startDate: string,
    endDate: string
  ): Promise<RoutineHistoryRecord[]>;
  abstract getDefinitions(): Promise<RoutineDefinition[]>;
  abstract createRoutine(input: RoutineInput): Promise<void>;
  abstract updateRoutine(definitionId: number, input: RoutineInput): Promise<void>;
  abstract setStatus(occurrenceId: number, status: RoutineStatus, quantity?: number | null): Promise<void>;
  abstract setSubtaskCompleted(subtaskId: number, completed: boolean): Promise<void>;
  abstract deactivateRoutine(definitionId: number, effectiveOn: string): Promise<void>;
  abstract reactivateRoutine(definitionId: number, activeFrom: string): Promise<void>;
  abstract archiveRoutine(definitionId: number, effectiveOn: string): Promise<void>;
}
